import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import Page from '../components/page';
import main from '../main';
import { goodsCatRequest } from '../redux/goodsCatReducer';
import { goodsListRequest } from '../redux/goodsListReducer';
import { routeNavRequest } from '../redux/routeNavReducer';
import { AppStore, Goods } from '../types';
import { dataListStatus, delay, parseLocationParams } from '../utils/utils';

const localFirstCatId = 'localFirstCatId';
const localSecondCatId = 'localSecondCatId';
export default function GoodsListPage() {
  const location = useLocation();
  const [firstCatId, setFirstCatId] = useState('');
  const [secondCatId, setSecondCatId] = useState('');
  const [shareUserId, setShareUserId] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: AppStore) => state.user);
  const navList = useSelector((state: AppStore) => state.routeNav);
  const catList = useSelector((state: AppStore) => state.goodsCat);
  const goodsList = useSelector((state: AppStore) => state.goodsList[secondCatId]);

  useEffect(() => {
    let { userId: uid } = parseLocationParams(location.search);
    if (uid) {
      setShareUserId(uid);
    }
    dispatch(routeNavRequest());
    dispatch(goodsCatRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!catList?.loaded || catList?.fetching) return;
    let _firstCatId = localStorage.getItem(localFirstCatId);
    let _secondCatId = localStorage.getItem(localSecondCatId);

    if (catList?.results?.length && !firstCatId) {
      let firstList = catList.results.filter((item) => item.parentId?.toString() === '0');
      let firstId = !firstCatId ? (!!_firstCatId ? _firstCatId : '') : firstCatId;
      if (!(firstList ?? []).map((i) => i.id!).includes(firstId)) {
        firstId = firstList[0].id!;
      }
      setFirstCatId(firstId);

      let secondList = catList.results.filter((item) => item.parentId === firstId);

      let secondId = !secondCatId ? (!!_secondCatId ? _secondCatId : '') : secondCatId;
      if (!(secondList ?? []).map((i) => i.id).includes(secondId)) {
        secondId = secondList[0].id!;
      }
      setSecondCatId(secondId);
      dispatch(goodsListRequest({ cat: secondId }));
      delay(1000).then((v) => {
        localStorage.removeItem(localFirstCatId);
        localStorage.removeItem(localSecondCatId);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catList]);

  function handleShare(detail: Goods) {
    navigate(`/share`, {
      state: {
        imgUrl: detail.goodsDetailImg ?? '',
        title: detail.goodsTitle ?? '',
        inviteUserId: user?.result?.id,
        goodsId: detail.id,
      },
    });
  }

  function buildTopBanner() {
    let topNavList = (navList?.results || []).filter((i) => i.type === 'navGoodsListTop');
    if (!topNavList.length) return <div></div>;
    if (topNavList.length === 1) {
      return <img className="w-355 h-85 m-10" src={topNavList[0].icon} alt="" />;
    } else {
      return (
        <Slider dots={false} autoplay={true} autoplaySpeed={3000}>
          {topNavList.map((i, idx) => (
            <div key={i.name ?? '' + idx} className="vw-100 p-10">
              <img className="w-355 h-85" src={i.icon} alt="" />
            </div>
          ))}
        </Slider>
      );
    }
  }

  function buildCat() {
    let firstList = catList?.results?.filter((item) => item.parentId?.toString() === '0');

    let secondList = catList?.results?.filter((item) => item.parentId === firstCatId);
    return (
      <div className="pt-10 pl-10 bg-color-white">
        <div className="d-flex-r flex-wrap">
          {firstList?.map((i, idx) => {
            return (
              <div
                key={i.id! + idx}
                className={`font-size-16 mr-5 font-widget-600 ${
                  firstCatId === i.id ? 'text-color-primary' : ''
                } ph-10 pv-5`}
                onClick={() => {
                  let _secondList = (catList?.results ?? []).filter((item) => item.parentId === i.id) ?? [];
                  setFirstCatId(i.id!);
                  let secondCatId = '1';
                  if (_secondList.length) {
                    secondCatId = _secondList[0].id!;
                  }
                  setSecondCatId(secondCatId);
                  dispatch(goodsListRequest({ cat: secondCatId }));
                }}
              >
                {i.sortName}
              </div>
            );
          })}
        </div>
        <div className="d-flex-r flex-wrap mt-10">
          {secondList?.map((i, idx) => (
            <div
              key={i.id! + idx}
              className={`font-size-12 mr-5 mb-5 border-radius-4 ${
                secondCatId === i.id ? 'text-color-white bg-color-primary' : ''
              } ph-8 pv-3`}
              onClick={() => {
                setSecondCatId(i.id!);
                dispatch(goodsListRequest({ cat: i.id! }));
              }}
            >
              {i.sortName}
            </div>
          ))}
        </div>
      </div>
    );
  }

  function buildGoodsList() {
    let bannerList = (navList?.results || [])
      .filter((i) => i.type === 'navGoodsListGoods')
      .sort((a, b) => (a.sortNum ?? 0) - (b.sortNum ?? 0));
    let pgoodsList = goodsList?.results ?? [];
    console.log(firstCatId)
    let t = pgoodsList.length / 4;
    let useBannerNum = Math.floor(Math.floor(t) === t ? t : t + 1);
    if (bannerList.length > useBannerNum) {
      bannerList = bannerList.slice(0, useBannerNum);
    }
    let items = [];
    for (var i = 0; i < pgoodsList.length; i++) {
      let goods = pgoodsList[i];
      items.push(
        <div
          key={goods.id! + i}
          className="w-172 bg-color-white mr-10 mb-10 border-radius-8 d-shadow"
          onClick={() => {
            localStorage.setItem(localFirstCatId, firstCatId);
            localStorage.setItem(localSecondCatId, secondCatId);
            if(firstCatId === '1847208625862438914'){
              return navigate(`/broadbandAccess?goodsId=${goods.id}`, {
                state: {
                 
                },
              });
            }
            if (goods.ifLink === 'Y' && goods.linkPath) {
              window.open(goods.linkPath);
              return;
            }
           
           
            
            navigate('/goods?goodsId=' + goods.id + '&canBack=true&userId=' + shareUserId);
          }}
        >
          <img src={goods.goodsListImg} className="w-172 h-172 border-radius-tl-8 border-radius-tr-8" alt="" />
          <div className="d-flex-r ai-center p-10">
            {!!goods.goodsTagIcon && (
              <img className="h-16 mr-5" src={main.pic(GoodsTagIcon.getTagIcon(goods.goodsTagIcon))} alt="" />
            )}
            <div className="omit-text flex-1 font-widget-600">{goods.goodsTitle}</div>
          </div>
          <div className="font-size-12 text-color-9 pl-10">已有{goods.virtualSales ?? 0}人下单</div>
          <div className="d-flex-r ai-start mh-10 mt-10">
            <div className="flex-1 d-flex-r flex-wrap">
              {!!goods.goodsTags &&
                goods.goodsTags!.split(',').map((i, idx) => (
                  <div
                    className="mr-5 mb-10 pv-1 ph-3 border-radius-4 font-size-12 text-color-red bg-color-red-t3"
                    key={i + idx}
                  >
                    {i}
                  </div>
                ))}
            </div>
            <img
              className="w-16 ml-5"
              src={main.pic('icon_export.png')}
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleShare(goods);
              }}
            />
          </div>
        </div>
      );
      var willBanner = false;
      if ((i + 1) % 4 === 0 || i === pgoodsList.length - 1) {
        willBanner = true;
      }
      if (willBanner && bannerList.length > 0) {
        var banner = bannerList.shift();
        items.push(
          <img key={banner?.name! + bannerList.length} className="w-355 h-85 m-10" src={banner?.icon} alt="" />
        );
      }
    }
    return <div className="d-flex-r flex-wrap pt-10 pl-10">{items}</div>;
  }

  let el = dataListStatus({ list: goodsList, tips: '暂无商品' });

  return (
    <Page contentClassName="bg-color-gray vw-100 vh-100 overflow-y d-flex-c">
      {buildTopBanner()}
      {buildCat()}
      {el ?? buildGoodsList()}
    </Page>
  );
}

/// 商品标题前的图标
export class GoodsTagIcon {
  /// 热卖
  static hot = 'hot';

  /// 秒杀
  static secondsKill = 'seconds_kill';

  /// 火爆
  static fieryFire = 'fiery_fire';

  /// 推荐
  static push = 'push';
  static getTagIcon(tag: string): string {
    const icons = {
      [GoodsTagIcon.hot]: 'icon_tag_sale.png',
      [GoodsTagIcon.secondsKill]: 'icon_tag_second_kill.png',
      [GoodsTagIcon.fieryFire]: 'icon_tag_hot.png',
      [GoodsTagIcon.push]: 'icon_tag_push.png',
    };
    return icons[tag] ?? '';
  }
}
